// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-box[data-v-4bf588fc] {\n  min-height: 300px;\n}", ""]);
// Exports
module.exports = exports;
